import React from 'react';
import DatePicker from 'react-datepicker';
import {Form, Select, Input} from 'semantic-ui-react';
import {WARRANTIES_TYPES} from '../../constants';
import {dateFormatPicker} from '../../../common/constants/datesFormat';

const SearchFormMany = ({
  statusSelect,
  handleChange,
  initDate,
  endDate,
  typeTwc,
  status,
  invoice,
}) => {
  return (
    <React.Fragment>
      <Form.Input fluid label='Fecha de inicial'>
        <DatePicker
          placeholderText='Fecha de inicial'
          className='tcc-datepicker'
          showYearDropdown
          selected={initDate}
          dateFormat={dateFormatPicker}
          onChange={(value) => handleChange('initDate', value)}
          locale='es'
        />
      </Form.Input>
      <Form.Input fluid label='Fecha de final'>
        <DatePicker
          placeholderText='Fecha de final'
          className='tcc-datepicker'
          showYearDropdown
          selected={endDate}
          dateFormat={dateFormatPicker}
          minDate={initDate}
          onChange={(value) => handleChange('endDate', value)}
          locale='es'
        />
      </Form.Input>
      <Form.Field
        control={Select}
        options={statusSelect}
        label='Estado'
        placeholder='Estado'
        value={status}
        onChange={(e, {value}) => handleChange('status', value)}
      />
      <Form.Field
        control={Select}
        options={WARRANTIES_TYPES}
        label='Tipo'
        placeholder='Tipo'
        value={typeTwc}
        onChange={(e, {value}) => handleChange('typeTwc', value)}
      />
      <Form.Field
        control={Input}
        label='Cuenta de cobro'
        placeholder='Cuenta de cobro'
        value={invoice}
        onChange={(e, {value}) => handleChange('invoice', value)}
      />
    </React.Fragment>
  );
};

export default SearchFormMany;
